import jwtDecode from 'jwt-decode';
import { getIdToken } from 'utils/auth-token/token';

export async function getUserTenantRole(tenantId) {
  const idToken = await getIdToken();
  const tenantsRole = JSON.parse(jwtDecode(idToken).tenantsRole);
  return tenantsRole[tenantId];
}
